/* eslint-disable no-useless-concat */
import { FETCH_AMAZON_SMILE } from './types';
import salomapi from '../apis';

export const fetchAmazonSmile = (code) => async dispatch => {
    const response = await salomapi.get('/spf/amazonaffiliate' + `${code ? '?region=' + code : ''}`);

    dispatch({ type: FETCH_AMAZON_SMILE, payload: response.data })
}
